import { useState, forwardRef } from 'react';
import { IonInput } from '@ionic/react';
import classnames from 'classnames';

export default forwardRef(function ValidatedInput({setValue, valid, ...props}, ref) {
  const [touched, setTouched] = useState(false);
  return (
    <IonInput
      ref={ref}
      onIonInput={(e) => setValue(e.target.value)}
      onIonBlur={(e) => setTouched(true)}
      className={classnames({'ion-valid': valid, 'ion-invalid': !valid, 'ion-touched': touched})}
      labelPlacement="floating"
      {...props}/>
  );
})
